const languages = [
    { code : 'en', name : 'English' },
    // { code : 'es', name : 'Spanish, Castilian' },
    // { code : 'hi', name : 'Hindi' },
    // { code : 'mr', name : 'Marathi' },
    // { code : 'id', name : 'Indonesian' },
    // { code : 'ne', name : 'Nepali' },
    // { code : 'pt', name : 'Portuguese' },
    // { code : 'ar', name : 'Arabic' },
    // { code : 'fr', name : 'French' },
    // { code : 'am', name : 'Amharic' },
    // { code : 'bn', name : 'Bengali' },
    // { code : 'so', name : 'Somali' },
    // { code : 'vi', name : 'Vietnamese' },
    // { code : 'om', name : 'Oromo' },
    // { code : 'tr', name : 'Turkish' },
    // { code : 'el', name : 'Greek (Modern)' },
];

export default languages;